import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/hypertask-static-homepage/hypertask-static-homepage/src/components/pages/LandingPage/Hero/hero-w45.tsx");
